export default {"src":"/_next/static/media/solar_wallet-money-linear.dc956961.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};